import _ from 'lodash';
import embedEditView from './embedEditComponent.html';
import './embedEditComponent.css';
import { stringify } from '../../url/serializer/urlSerializer.js';
import { ensure } from 'components/sharpr/ensure/ensure.js';

export function embedEditComponent() {
	return {
		bindings: {
			embed: '=',
			templateString: '<',
			onClose: '&',
			showStandardController: '<',
			termCodeDefault: '@',
			termCodeLabel: '@',
		},
		controllerAs: 'vm',
		controller: embedEditComponentCtrl,
		template: embedEditView,
	};
}

export class embedEditComponentCtrl {
	constructor(Api, $sce, modal, notifications) {
		'ngInject';
		this.Api = Api;
		this.$sce = $sce;
		this.modal = modal;
		this.notifications = notifications;
		this.debouncedUpdatePreview = _.throttle(this.updatePreview.bind(this), 300, {
			leading: false,
			trailing: true,
		});
	}

	$onInit() {
		this.embedString = '';
		this.originalRecord = Object.assign({}, this.embed);
		this.loadSsoCodes();
		this.updatePreview();
		this.updateEmbedString();
	}

	loadSsoCodes() {
		this.Api.get('/auth/sso_codes').then(
			data => {
				if (_.isEmpty(data)) {
					return;
				}
				this.ssoCodeOptions = ensure.array(data).map(code => ({ id: code, name: code }));
				this.ssoCodeOptions.unshift({
					id: '',
					code: 'None',
				});
				this.embed.config.sso_code = this.embed.config.sso_code || this.ssoCodeOptions[1].id;
				this.updateEmbedString();
			},
			() => {}
		);
	}

	validateWidth() {
		const width = parseInt(this.embed.config.image_width, 10);
		if (isNaN(width)) {
			this.modal.alert({ text: 'Image width must be a number.' });
			this.embed.config.image_width = 60;
		}
		this.updatePreview();
	}

	validateHeight() {
		const height = parseInt(this.embed.config.image_height, 10);
		if (isNaN(height) || height < 18) {
			this.embed.config.image_height = 18;
			this.modal.alert({ text: 'Image height must be a number greater than 17.' });
		}
		this.updatePreview();
	}

	getEmbedUrl() {
		return `${window.BASE_URL}/embed/mini/${this.embed.uuid}`;
	}

	updatePreview() {
		const config = this.embed.config;
		const params = stringify({
			limit: config.limit,
			term: this.showStandardController ? '' : config.term_code,
			term_behavior: config.term_behavior,
			use_padding: config.use_padding,
			view_all_label: config.view_all_label,
			none_found_message: config.none_found_message,
			line_clamp_headline: config.line_clamp_headline,
			line_clamp_body: config.line_clamp_body,
			column_width: config.column_width,
			image_width: config.image_width,
			image_height: config.image_height,
			hub_type: config.hub_type,
			hub_ids: config.hub_ids,
			is_preview: true,
		});
		const url = `${this.getEmbedUrl()}${params}`;
		this.previewUrl = this.$sce.trustAsResourceUrl(url);
		return url;
	}

	updateEmbedString() {
		const config = Object.assign({}, this.embed.config);
		config.url = this.getEmbedUrl();
		config.width = parseInt(config.iframe_width, 10);
		config.height = parseInt(config.iframe_height, 10);
		if (config.allow_public_access) {
			config.sso = '';
		} else {
			config.sso = encodeURIComponent(config.sso_code || '');
		}
		config.term = this.encodeApexURIComponent(config.term_code);
		config.standardController = this.encodeApexURIComponent(config.controller_code);
		this.embedString = this.templateString.replace(/\{([\w_]+)\}/g, ($0, $1) => {
			return config[$1] || '';
		});
		if (!this.showStandardController) {
			this.debouncedUpdatePreview();
		}
	}

	/**
	 * Use URI encoding except for braces that Apex looks for
	 * @param {String} urlComponent  The url component
	 * @returns {string}
	 */
	encodeApexURIComponent(urlComponent) {
		return encodeURIComponent(urlComponent).replace(/%7B/g, '{').replace(/%7D/g, '}');
	}

	cancel() {
		Object.assign(this.embed, this.originalRecord);
		this.close();
	}

	close() {
		this.onClose && this.onClose();
	}

	save() {
		this.Api.patch(`/embed_configs/${this.embed.uuid}`, {
			label: this.embed.label,
			config: this.embed.config,
		}).then(
			() => {
				this.close();
				this.notifications.showSuccess({ message: 'Embed saved ok.' });
			},
			() => {}
		);
	}
}
